import { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import Text, { createStyledText } from './Text'

const Input = styled.input`
  outline: none;
  border: none;
  background-color: transparent;
  width: 100%;

  // input은 브라우저 기본 폰트를 렌더링 하므로 상속 필요
  font-family: inherit;

   // input value 텍스트 설정
  ${({ theme }) =>
    createStyledText({ theme, variant: "headline2", weight: "medium"})}

  // placeholder 텍스트 설정
  &::placeholder {
  ${({ theme }) =>
      createStyledText({ theme, variant: "headline2", weight: "medium", color: "assistive" })}
  }
`

const EditableTitleInput = ({ title, onChange }) => {
  const [isEditing, setIsEditing] = useState(false)
  const [value, setValue] = useState(title);
  const inputRef = useRef(null);

  // 부모 title 변경 → 내부 value 갱신
  useEffect(() => {
    setValue(title);
  }, [title]);

  useEffect(() => {
    if (isEditing) inputRef.current?.focus();
  }, [isEditing]);

  const handleSave = () => {
    setIsEditing(false);
    const trimmed = value.trim();
    const newValue = trimmed === '' ? '새로운 대화' : trimmed;
    setValue(newValue);
    if (trimmed !== title) {
      onChange(newValue);
    }
  };

  return (
    isEditing ? (
      <Input
        ref={inputRef}
        placeholder="제목을 입력해주세요."
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onBlur={handleSave}
      />
    ) : (
      <div onClick={() => setIsEditing(true)}>
        <Text variant="headline2" weight="medium">{title}</Text>
      </div>
    ) 
  )
}

export default EditableTitleInput
